// extracted by mini-css-extract-plugin
export default {"root":"TableActions_root__I7A9Q","action":"TableActions_action__mMBQn","linkAction":"TableActions_linkAction__IqZ16"};